import { render, staticRenderFns } from "./VModalWithAside.vue?vue&type=template&id=50407bed"
import script from "./VModalWithAside.vue?vue&type=script&lang=js"
export * from "./VModalWithAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports